import { render, staticRenderFns } from "./inputCheckbox.vue?vue&type=template&id=2cb51752&scoped=true"
import script from "./inputCheckbox.vue?vue&type=script&lang=js"
export * from "./inputCheckbox.vue?vue&type=script&lang=js"
import style0 from "./inputCheckbox.vue?vue&type=style&index=0&id=2cb51752&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb51752",
  null
  
)

export default component.exports